import Vue from 'vue';
import Vuex from 'vuex';
import d2admin from './modules/d2admin';
import { $dataRoomStore } from '@gcpaas/data-room-ui';
Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    d2admin: d2admin,
    // 注册大屏设计器的store
    bigScreen: $dataRoomStore
  }
});